module.exports = __webpack_public_path__ + "static/img/business.93b3e442.png";